// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1D4Rv","type":"styles_type__4Funt","choices":"styles_choices__3OgwG"};